export enum AttestationPurpose {
  forConsumers = 'For Consumers',
  forVerifiers = 'For Verifiers',
  forEmployers = 'For Employers',
  forPeo = 'For PEO',
  forCvStaff = 'For CV Staff',
  forPeoPp = 'For Peo Payroll Provider',
}
